<template>

<b-table striped hover class="small-font" :fields="fields" :items="items" :per-page="perPage" :current-page="currentPage"
         no-local-sorting @sort-changed="$emit('sortChanged', $event)" @row-clicked="clickEnFila">
  <template slot="validationStatus" slot-scope="{item, value}">
    <div v-if="editableStatus && item.workOrderType === 'PROJECT'" class="d-flex">
      {{ value }}
      <fa-icon @click="$emit('click-edit-status', item)" class="ml-auto text-primary" style="cursor: pointer;" icon="edit"/>
    </div>
    <span v-else>{{ value }}</span>
  </template>
  <template slot="workOrderDate" slot-scope="data">{{data.item.workOrderDate | moment('DD/MM/YYYY')}}</template>
  <template slot="buttons" slot-scope="data">
    <b-button v-if="includeConfirmButton" @click.stop="$emit('click-confirm', data.item)" variant="success" size="sm">
      <fa-icon icon="check"/>
    </b-button>
    <b-button v-if="includeEditButton" @click.stop="$emit('clickEdit', data.item)" variant="primary" size="sm">
      <fa-icon icon="edit" ref="editButton"/>
    </b-button>
    <b-button v-if="includeShowButton" @click.stop="$emit('clickShow', data.item)" variant="primary" size="sm">
      <fa-icon icon="eye"/>
    </b-button>
    <b-button v-if="includeDeleteButton" @click.stop="$emit('click-delete', data.item)" variant="danger" size="sm">
      <fa-icon icon="trash-alt"/>
    </b-button>
  </template>
</b-table>

</template>

<script>

const MEAL_COST_OPTIONS = {
  FULL: {value: 'FULL', text: 'Completa'},
  HALF: {value: 'HALF', text: 'Media'},
  NONE: {value: 'NONE', text: 'Ninguna'}
}
const translateMealCost = value => MEAL_COST_OPTIONS[value].text
const formatDecimal = value => value % 1 === 0 ? value : value.toFixed(2).replace('.', ',')

export default {
  name: 'WorkOrderTable',
  props: {
    items: {type: Array, required: true},
    buttons: {type: Array, default: () => []},
    perPage: {type: Number, default: 0},
    currentPage: {type: Number, default: 0},
    editableStatus: {type: Boolean, default: false},
    fields: {
      type: Array,
      default: () => [
        {key: 'id', label: 'Parte', sortable: true, thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
        {
          key: 'workOrderType',
          label: 'Tipo',
          sortable: true,
          formatter: (v, k, item) => item.typeLabel,
          thStyle: {width: '80px'},
          tdAttr: {width: '80px'}
        },
        {key: 'validationStatus', label: 'Estado', sortable: true, formatter: (v, k, item) => item.statusLabel},
        {key: 'workOrderDate', label: 'Fecha', sortable: true},
        {key: 'employeeName', label: 'Operario', sortable: true},
        {key: 'projectCodeId', label: 'Proyecto', sortable: true, formatter: (v, k, item) => v + ' - ' + item.projectTitle},
        {key: 'project.client.name', label: 'Cliente', sortable: true, formatter: (v, k, item) => item.clientName},
        {
          key: 'preventiveResource',
          label: 'Recurso',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {key: 'ordinaryHours', label: 'Horas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
        {key: 'overtimeHours', label: 'Extra', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
        {key: 'holidayHours', label: 'Festivas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
        {key: 'pauseHours', label: 'Pausa', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
        {
          key: 'mealCostType',
          label: 'Dietas',
          thStyle: {width: '50px'},
          tdAttr: {width: '50px'},
          formatter: v => translateMealCost(v)
        },
        {key: 'travelKm', label: 'Km', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
        {
          key: 'shiftWork',
          label: 'Turnicidad',
          class: 'text-center',
          thStyle: {width: '75px'},
          tdAttr: {width: '75px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {
          key: 'nightShift',
          label: 'Nocturnidad',
          class: 'text-center',
          thStyle: {width: '90px'},
          tdAttr: {width: '90px'},
          formatter: v => v ? 'Si' : 'No'
        },

        {
          key: 'onCallDuty',
          label: 'Guardia',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {
          key: 'saturday',
          label: 'Sábado',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },
        {
          key: 'holiday',
          label: 'Festivo',
          class: 'text-center',
          thStyle: {width: '60px'},
          tdAttr: {width: '60px'},
          formatter: v => v ? 'Si' : 'No'
        },

        {key: 'comments', label: 'Observaciones'},
        {key: 'buttons', label: 'Gestión'}
      ]
    }
  },
  computed: {
    includeEditButton() {
      return this.buttons.includes('edit')
    },
    includeShowButton() {
      return this.buttons.includes('show')
    },
    includeDeleteButton() {
      return this.buttons.includes('delete')
    },
    includeConfirmButton() {
      return this.buttons.includes('confirm')
    }
  },
  methods: {
    clickEnFila(record, index) {
      this.$emit('clickEdit', record)
    }
  }
}

</script>

<style lang="scss" scoped>
  .small-font {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/workOrder/partials/WorkOrderTable.vue